/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ detail: NonNullable<unknown> }} Workout_Logging_Fill_Below_DoneInputs */

const en_us2_workout_logging_fill_below_done = /** @type {(inputs: Workout_Logging_Fill_Below_DoneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Next sets set to ${i?.detail}`)
};

const pt_br2_workout_logging_fill_below_done = /** @type {(inputs: Workout_Logging_Fill_Below_DoneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Próximas séries com ${i?.detail}`)
};

const es_419_workout_logging_fill_below_done = /** @type {(inputs: Workout_Logging_Fill_Below_DoneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Siguientes series con ${i?.detail}`)
};

const pt_pt2_workout_logging_fill_below_done = /** @type {(inputs: Workout_Logging_Fill_Below_DoneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Próximas séries com ${i?.detail}`)
};

const fr_fr2_workout_logging_fill_below_done = /** @type {(inputs: Workout_Logging_Fill_Below_DoneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Séries suivantes réglées sur ${i?.detail}`)
};

const de_de2_workout_logging_fill_below_done = /** @type {(inputs: Workout_Logging_Fill_Below_DoneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Nächste Sätze auf ${i?.detail} gesetzt`)
};

const it_it2_workout_logging_fill_below_done = /** @type {(inputs: Workout_Logging_Fill_Below_DoneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Serie successive impostate a ${i?.detail}`)
};

/**
* | output |
* | --- |
* | "Next sets set to {detail}" |
*
* @param {Workout_Logging_Fill_Below_DoneInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_logging_fill_below_done = /** @type {((inputs: Workout_Logging_Fill_Below_DoneInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Logging_Fill_Below_DoneInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_logging_fill_below_done(inputs)
	if (locale === "es-419") return es_419_workout_logging_fill_below_done(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_logging_fill_below_done(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_logging_fill_below_done(inputs)
	if (locale === "de-DE") return de_de2_workout_logging_fill_below_done(inputs)
	if (locale === "it-IT") return it_it2_workout_logging_fill_below_done(inputs)
	return en_us2_workout_logging_fill_below_done(inputs)
});
export { workout_logging_fill_below_done as "workout-logging.fill_below_done" }